import React from 'react';

const RuleStatusBadge = ({ status }) => {
  let colorClasses = 'bg-gray-100 text-gray-800'; // Default / Draft

  switch (status?.toLowerCase()) {
    case 'draft':
      colorClasses = 'bg-gray-100 text-gray-800 border border-gray-200';
      break;
    case 'published':
      colorClasses = 'bg-green-100 text-green-800 border border-green-200';
      break;
    case 'archived':
      colorClasses = 'bg-red-100 text-red-800 border border-red-200';
      break;
    default:
      break;
  }

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium shadow-sm transition-colors duration-200 ${colorClasses}`}>
      {status || 'Unknown'}
    </span>
  );
};

export default RuleStatusBadge;
